import {useGetInfiniteRestVials} from '@/modules/stocks/rest-vials/api'
import {RestVialsHeader} from '@/modules/stocks/rest-vials/components/rest-vials-header'
import {RestVialsTable} from '@/modules/stocks/rest-vials/components/rest-vials-table'
import {RestVialsSearchSchema} from '@/modules/stocks/rest-vials/schemas'
import {Box} from '@chakra-ui/react'
import {createFileRoute} from '@tanstack/react-router'
import {type OnChangeFn, type SortingState} from '@tanstack/react-table'
import {useCallback} from 'react'

export const Route = createFileRoute('/stocks/rest-vials/')({
  component: RestVialsPage,
  validateSearch: RestVialsSearchSchema,
})

const LIMIT = 50

function RestVialsPage() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  const [sort] = search.sort

  const infiniteRestVials = useGetInfiniteRestVials({
    limit: LIMIT,
    filters: search.filters,
    sort: {
      dir: sort?.desc ? 'desc' : 'asc',
      field: sort?.id || 'createdAt',
    },
  })

  const {getPageQuery, getSingleQuery, toStartRow, listContextParams} = infiniteRestVials

  const onSortingChange = useCallback<OnChangeFn<SortingState>>(
    updaterOrValue => {
      const newValue = typeof updaterOrValue === 'function' ? updaterOrValue(search.sort) : updaterOrValue
      navigate({to: '.', search: prev => ({...prev, sort: newValue})})
    },
    [navigate, search.sort]
  )

  return (
    <>
      <Box flexShrink={0}>
        <RestVialsHeader />
      </Box>

      <RestVialsTable
        virtualizer={{getPageQuery, getSingleQuery, toStartRow, listContextParams}}
        table={{state: {sorting: search.sort}}}
        sorting={search.sort}
        onSortingChange={onSortingChange}
      />
    </>
  )
}
